import React from "react";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import Icon from "../../../components/AppIcon";
import { useTranslation } from "react-i18next";

const AddressInfoSection = ({
  address,
  province,
  provinces,
  onAddressChange,
  onProvinceChange,
  errors = {},
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-card rounded-lg shadow-soft p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center">
          <Icon name="MapPin" size={20} className="text-success" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-card-foreground">
            {t("addressInformation")}
          </h2>
          <p className="text-text-secondary text-sm">{t("updateLocation")}</p>
        </div>
      </div>

      <div className="space-y-6">
        <div>
          <Input
            label={t("address")}
            type="text"
            value={address}
            onChange={(e) => onAddressChange(e.target.value)}
            required
            error={errors.address}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <select
              name="province"
              value={province}
              onChange={(e) => onProvinceChange(e.target.value)}
              className={`block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out hover:border-blue-400 ${
                errors.province_id ? "border-red-500" : ""
              }`}
              required
              error={errors.province}
            >
              <option value="" disabled>
                {t("selectProvince")}
              </option>
              {provinces.map((province) => (
                <option key={province.id} value={province.id}>
                  {province.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressInfoSection;
